const PASSWORD_PATTERN =/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{}:;"',.?/~`])[A-Za-z0-9!@#$%^&*()_+\-=[\]{}:;"',.?/~`]{8,20}$/;
interface PasswordDomConfig {
  newPasswordId: string;
  newPasswordMsgId: string;
  confirmPasswordId?: string;
  confirmPasswordMsgId?: string;
}

export const validatePasswordWithDOM = (
  newPassword: string,
  confirmPassword: string | undefined,
  passwordNotMatchMessage: string,
  config: PasswordDomConfig
): {
  isPasswordFieldsValid: boolean;
  passwordsMatch: boolean;
} => {
  let isPasswordFieldsValid = true;
  let passwordsMatch = true;

  const newPwdInput = document.getElementById(config.newPasswordId);
  const newPwdMsg = document.getElementById(config.newPasswordMsgId);
  const confirmPwdInput = config.confirmPasswordId
    ? document.getElementById(config.confirmPasswordId)
    : null;
  const confirmPwdMsg = config.confirmPasswordMsgId
    ? document.getElementById(config.confirmPasswordMsgId)
    : null;

  if (!newPassword || !confirmPassword) {
    isPasswordFieldsValid = false;
  }

  // New password and confirm password fields validation
  if (newPassword && !PASSWORD_PATTERN.test(newPassword)) {
    isPasswordFieldsValid = false;
    if (newPwdInput) (newPwdInput as HTMLElement).style.border = "1px solid red";
    if (newPwdMsg) newPwdMsg.innerHTML = "Please match the format requested.";
  } else {
    if (newPwdInput) (newPwdInput as HTMLElement).style.border = "";
    if (newPwdMsg) newPwdMsg.innerHTML = "";
  }

  // Confirm password match validation
  if (newPassword && confirmPassword && newPassword !== confirmPassword) {
    isPasswordFieldsValid = false;
    passwordsMatch = false;

    if (confirmPwdInput)
      (confirmPwdInput as HTMLElement).style.border = "1px solid red";
    if (confirmPwdMsg)
      confirmPwdMsg.innerHTML = passwordNotMatchMessage
        "New Password and Confirm New Password fields do not match.";
  } else {
    if (confirmPwdInput) (confirmPwdInput as HTMLElement).style.border = "";
    if (confirmPwdMsg) confirmPwdMsg.innerHTML = "";
  }

  return {
    isPasswordFieldsValid,
    passwordsMatch,
  };
};
